<template>
  <div class="todoList column">
    <div class="row flex-center">
      <div class="flex-1"></div>

      <div class="status" @click="updateStatus">
        {{ statusText }}
        <span class="iconfont icon-arr-xia"></span>
      </div>
    </div>
    <div class="flex-1 overflow-y todoitemList">
      <div class="toDoItem" v-for="(row, index) in list" :key="index">
        <div class="top row flex-center">
          <div class="flex-1 typename">{{ row.taskType }}</div>

          <div
            v-if="row.status == 0 && row.sopTaskId == 0"
            class="editBtn"
            @click="itemDelete(row)"
          >
            删除
          </div>
          <div
            v-if="row.status == 0"
            class="editBtn green"
            @click="itemFinish(row)"
          >
            完成
          </div>

          <div v-if="row.status == 1" class="status success">已完成</div>

          <div v-if="row.status == 2" class="status todo">未完成</div>

          <div v-if="row.status == 3" class="status gary">已取消</div>
        </div>
        <div class="contInfo">
          <div>{{ row.content }}</div>
          <div v-if="row.status == 0" class="plantime">
            计划时间：{{ row.planDate }}
          </div>
          <div v-if="row.status == 1" class="plantime">
            完成时间：{{ $filters.formatDateTime(row.finishTime) }}
          </div>
        </div>

        <!-- <div class="useredit row flex-center">
          <div class="flex-1 row flex-center">
            <div class="userHead iconfont icon-yy"></div>
            <div class="flex-1 username">{{row.name}}</div>
          </div>
          <div class="iconfont icongroup icon-yy"></div>
          <div class="iconfont iconsingal icon-yy"></div>
        </div> -->
      </div>

      <EmptyImgh5 v-if="list.length == 0"></EmptyImgh5>
    </div>
    <div class="toCreateBtn" @click="toCreate()">新建待办</div>
  </div>

  <van-popup
    v-model:show="statusTip.isShow"
    position="bottom"
    :style="{ height: '40%' }"
  >
    <van-picker
      title="状态"
      :value="subdata.status"
      :columns="statusOption"
      @confirm="statusConfirm"
      @cancel="statusCancel"
    />
  </van-popup>
</template>

<script>
import {
  enterpriseMicroTodoList,
  deleteEnterpriseMicroTodo,
  completeEnterpriseMicroTodo,
} from "@/api/patient.js";
import func from "@/util/func.js";
import { userStore } from "@/store/user";

import { contactCardProps, showToast, showConfirmDialog } from "vant";

export default {
  name: "list",
  props: [],
  components: {},
  data() {
    return {
      subdata: {
        planDate: "",
        status: "0",
      },
      statusOption: [
        { text: "未完成", value: "0" },
        { text: "已完成", value: "1" },
        // { text: "未成功", value: "2" },
        // { text: "已取消", value: "3" },
      ],
      statusTip: {
        isShow: false,
      },
      list: [],
    };
  },
  setup() {},
  mounted() {
    this.getList();
  },
  computed: {
    statusText() {
      switch (this.subdata.status) {
        case "1":
          return "已完成";
        case "2":
          return "未成功";
        case "3":
          return "已取消";
        default:
          return "未完成";
      }
    },
  },
  methods: {
    getList() {
      let that = this;
      const aloginStoreuth = userStore();
      let subdata = {
        agentId: aloginStoreuth.agentId,
        corpId: aloginStoreuth.corpId,
        cusId: aloginStoreuth.cusId,
        status: that.subdata.status,
      };

      that.list = [];
      enterpriseMicroTodoList(subdata).then((res) => {
        let { data } = res.data;
        that.list = data;
      });
    },
    toCreate() {
      this.$emit("toCreate");
    },
    updateStatus() {
      this.statusTip.isShow = true;
    },
    statusConfirm(value) {
      let that = this;
      that.subdata.status = value.selectedValues[0];
      that.statusTip.isShow = false;
      that.getList();
    },
    statusCancel() {
      this.statusTip.isShow = false;
    },
    itemDelete(row) {
      let that = this;
      showConfirmDialog({
        title: "删除待办",
        message: `确认删除待办任务吗`,
      }).then(() => {
        deleteEnterpriseMicroTodo({ id: row.id }).then((res) => {
          showToast("删除成功");
          that.getList();
        });
      });
      // 在这里编写删除方法的实现
    },
    itemFinish(row) {
      // 在这里编写完成方法的实现
      let that = this;
      showConfirmDialog({
        title: "完成待办",
        message: `确认完成待办任务吗`,
      }).then(() => {
        completeEnterpriseMicroTodo({ id: row.id }).then((res) => {
          showToast("操作成功");
          that.getList();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.todoList {
  font-size: 0.292rem;
  box-sizing: border-box;
  flex: 1;
  height: 0;
  padding-bottom: 0.25rem;

  .status {
    color: #28b8c3;
  }

  .toCreateBtn {
    background-color: #28b8c3;
    color: #fff;
    padding: 0.208rem;
    border-radius: 0.083rem;
  }
  .todoitemList {
    padding: 0.208rem 0 0.209rem 0;
    margin-bottom: 0.208rem;
  }
  .toDoItem {
    text-align: left;
    padding: 0.25rem;
    border: 0.021rem solid #ededed;
    border-radius: 0.167rem;
    margin-top: 0.208rem;
    .top {
      padding-bottom: 0.083rem;
      .typename {
        color: #333;
      }
      .status {
        font-size: 0.25rem;
        padding: 0.083rem 0.125rem;
        border-radius: 0.042rem;

        &.todo {
          background: #fff7e8;
          color: #faad14;
        }

        &.failed {
          background: #ffeded;
          color: #ff4d4f;
        }

        &.success {
          background: rgb(227, 251, 215);
          color: rgb(82, 196, 26);
        }

        &.gary {
          background: #ededed;
          /* 或者使用具体的灰色色值，比如 #808080 */
          color: #666;
          /* 同样可以使用具体的灰色色值 */
        }
      }
    }

    .editBtn {
      padding: 0.083rem 0.208rem;
      border: 0.021rem solid #ccc;
      margin-left: 0.208rem;
      border-radius: 0.083rem;
      font-size: 0.25rem;
      &.green {
        color: #28b8c3;
        border: 0.021rem solid #28b8c3;
      }
    }

    .contInfo {
      margin-top: 0.083rem;
      color: #999;
      font-size: 0.292rem;
      .plantime {
        margin-top: 0.125rem;
      }
    }

    .useredit {
      padding-top: 0.167rem;
      .userHead {
        width: 28px;
        height: 28px;
        background-color: #e6e6e6;
      }
      .username {
        color: #999999;
        margin-left: 0.208rem;
      }
      .icongroup {
        font-size: 0.292rem;
        margin-right: 0.208rem;
        font-size: 0.417rem;
      }
      .iconsingal {
        font-size: 0.292rem;
        margin-right: 0.208rem;
        font-size: 0.417rem;
      }
    }
  }
}
</style>
